import toast from "react-hot-toast";
import { Helmet } from "react-helmet";
import PropTypes from "prop-types";
import React, { Component } from "react";
import HttpDataSource from "../api/HttpDataSource";

class AdminTelechargements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      orderId: "",
      products: [],
      selectedProducts: [],
      loaded: false
    };
  }

  errorMessage = (error) => {
    if (error.message) return error.message;
    if (error.response && error.response.data && error.response.data.error) {
      return error.response.data.error;
    }
    return this.props.t("Une erreur est survenue");
  };

  async fetchProducts(orderId) {
    const data = await HttpDataSource.getOrderProductsData(orderId);
    this.setState({
      products: data.result || [],
      selectedProducts: [],
      loaded: true
    });
  }

  loadProducts = async () => {
    const { t } = this.props;
    const orderId = this.state.orderId.trim();

    if (!orderId) {
      toast.error(t("Veuillez entrer un numéro de commande"));
      return;
    }

    this.setState({ isLoading: true });

    try {
      await this.fetchProducts(orderId);
      this.setState({ isLoading: false });
    } catch (error) {
      toast.error(this.errorMessage(error));
      this.setState({ isLoading: false });
    }
  }

  handleOrderIdChange = (e) => {
    this.setState({ orderId: e.target.value });
  };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.loadProducts();
    }
  };

  toggleSelect = (productId) => {
    this.setState((prevState) => {
      const selectedProducts = prevState.selectedProducts.includes(productId)
        ? prevState.selectedProducts.filter((id) => id !== productId)
        : [...prevState.selectedProducts, productId];

      return { selectedProducts };
    });
  };

  async resetDownloads(ids) {
    const { t } = this.props;
    const orderId = this.state.orderId.trim();

    this.setState({ isLoading: true });

    try {
      await HttpDataSource.resetOrderDownloadsData({
        id_commande: orderId,
        ids_produits_shopify: ids
      });
      toast.success(t("Les téléchargements ont été réinitialisés"));
      await this.fetchProducts(orderId);
      this.setState({ isLoading: false });
    } catch (error) {
      toast.error(this.errorMessage(error));
      this.setState({ isLoading: false });
    }
  }

  handleResetAll = () => {
    this.resetDownloads(null);
  };

  handleResetSelected = () => {
    if (this.state.selectedProducts.length === 0) {
      toast.error(
        this.props.t("Veuillez sélectionner au moins un produit")
      );
      return;
    }
    this.resetDownloads(this.state.selectedProducts);
  };

  render() {
    const { t } = this.props;

    return (
      <>
        <Helmet>
          <title>{t("Réinitialiser les téléchargements")}</title>
          <meta
            name="description"
            content={t("Réinitialiser les téléchargements")}
          />
        </Helmet>
        <div className="flex justify-between flex-wrap-6 bg-donaPurple p-2 border border-donaPurple rounded">
          <h1 className="text-white font-bold mt-2">
            {t("Réinitialiser les téléchargements")}
          </h1>
        </div>

        <div className="flex flex-wrap items-center mt-4 mb-4">
          <label
            htmlFor="orderId"
            className="mr-2 text-donaPurple font-bold"
          >
            {t("Numéro de commande")}
          </label>
          <input
            id="orderId"
            type="number"
            value={this.state.orderId}
            onChange={this.handleOrderIdChange}
            onKeyDown={this.handleKeyDown}
            className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            placeholder={t("Numéro de commande")}
            aria-label={t("Numéro de commande")}
          />
          <button
            type="button"
            onClick={this.loadProducts}
            disabled={this.state.isLoading}
            className="ml-2 px-4 py-2 rounded bg-donaPurple text-white font-bold hover:bg-donaBlue focus:outline-none disabled:opacity-50"
          >
            {t("Charger les produits")}
          </button>
        </div>

        {this.state.loaded && (
          <div className="flex flex-wrap items-center mb-4">
            <button
              type="button"
              onClick={this.handleResetAll}
              disabled={this.state.isLoading}
              className="px-4 py-2 rounded bg-donaPurple text-white font-bold hover:bg-donaBlue focus:outline-none disabled:opacity-50"
            >
              {t("Réinitialiser tous les téléchargements")}
            </button>
            <button
              type="button"
              onClick={this.handleResetSelected}
              disabled={this.state.isLoading}
              className="ml-2 px-4 py-2 rounded border border-donaPurple text-donaPurple font-bold hover:bg-donaPurple hover:text-white focus:outline-none disabled:opacity-50"
            >
              {t("Réinitialiser la sélection")}
            </button>
          </div>
        )}

        {this.state.loaded && this.state.products.length === 0 && (
          <p className="mt-4">{t("Aucun produit trouvé pour cette commande")}</p>
        )}

        {this.state.loaded && this.state.products.length > 0 && (
          <table className="table-auto w-full">
            <thead>
              <tr className="bg-donaGray">
                <th scope="col" className="px-5 py-4 text-left text-donaPurple font-bold" />
                <th scope="col" className="px-5 py-4 text-left text-donaPurple font-bold">
                  {t("ISBN")}
                </th>
                <th scope="col" className="px-5 py-4 text-left text-donaPurple font-bold">
                  {t("Titre du produit")}
                </th>
                <th scope="col" className="px-5 py-4 text-left text-donaPurple font-bold">
                  {t("Quantité")}
                </th>
                <th scope="col" className="px-5 py-4 text-left text-donaPurple font-bold">
                  {t("Téléchargements")}
                </th>
                <th scope="col" className="px-5 py-4 text-left text-donaPurple font-bold">
                  {t("Télécharger")}
                </th>
              </tr>
            </thead>
            <tbody>
              {this.state.products.map((product) => (
                <tr key={product.id_produit_shopify}>
                  <td className="px-5 py-4 text-left border-b border-gray-200 text-md leading-5 text-black">
                    <input
                      type="checkbox"
                      checked={this.state.selectedProducts.includes(
                        product.id_produit_shopify
                      )}
                      onChange={() => this.toggleSelect(product.id_produit_shopify)}
                      aria-label={product.isbn}
                    />
                  </td>
                  <td className="px-5 py-4 text-left border-b border-gray-200 text-md leading-5 text-black">
                    {product.isbn}
                  </td>
                  <td className="px-5 py-4 text-left border-b border-gray-200 text-md leading-5 text-black break-words">
                    {product.titre_produit_shopify}
                  </td>
                  <td className="px-5 py-4 text-left border-b border-gray-200 text-md leading-5 text-black">
                    {product.quantite}
                  </td>
                  <td className="px-5 py-4 text-left border-b border-gray-200 text-md leading-5 text-black">
                    {product.nombre_telechargements}
                  </td>
                  <td className="px-5 py-4 text-left border-b border-gray-200 text-md leading-5 text-black">
                    <a
                      href={product.hyperlien}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={
                        product.hyperlien
                          ? "inline-block px-4 py-2 rounded bg-donaPurple text-white font-bold hover:bg-donaBlue focus:outline-none"
                          : "inline-block px-4 py-2 rounded bg-donaGray text-white font-bold pointer-events-none"
                      }
                    >
                      {t("Télécharger")}
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </>
    );
  }
}

AdminTelechargements.propTypes = {
  t: PropTypes.func
};

export default AdminTelechargements;